import { isEqual } from 'lodash';
import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

export const useDeepCompareEffect = (callback: EffectCallback, dependencies: DependencyList) => {
  const ref = useRef<DependencyList>(dependencies);

  if (!isEqual(dependencies, ref.current)) {
    ref.current = dependencies;
  }

  // eslint-disable-next-line react-compiler/react-compiler
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(callback, ref.current);
};
